"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Box_1 = __importDefault(require("@mui/material/Box"));
const TableSortLabel_1 = __importDefault(require("@mui/material/TableSortLabel"));
const Checkbox_1 = __importDefault(require("@mui/material/Checkbox"));
const Tooltip_1 = __importDefault(require("@mui/material/Tooltip"));
const Paper_1 = __importDefault(require("@mui/material/Paper"));
const QListHeader = ({ columnData, onSelectAllClick, order, orderBy, numSelected, rowCount, disableDelete, onRequestSort, }) => {
    let first = true;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };
    return (<Paper_1.default elevation={0}>
      <Box_1.default display="flex">
        {!disableDelete && (<Box_1.default minWidth={45} flex={0} pl={0}>
            <Checkbox_1.default color="primary" inputProps={{ 'aria-label': 'Select All', id: 'checkbox-select-all' }} sx={{
                pl: 0,
                height: '30px',
                fontSize: '21px',
            }} indeterminate={numSelected > 0 && numSelected < rowCount} checked={numSelected === rowCount} onChange={onSelectAllClick}/>
          </Box_1.default>)}
        {/* eslint-disable no-return-assign */}
        {columnData.map((column) => (<Paper_1.default key={column.id} elevation={0} sx={{
                flex: column.flex,
                fontSize: '14px',
                marginTop: 'auto',
                marginBottom: 'auto',
                textAlign: 'left',
            }}>
            <Tooltip_1.default title="Sort" placement={column.numeric ? 'bottom-end' : 'bottom-start'} enterDelay={300}>
              <TableSortLabel_1.default sx={{
                color: 'graniteGrey',
                paddingLeft: first ? 0 : 0,
            }} active={orderBy === column.id} direction={order} onClick={createSortHandler(column.id)} id={`sort-by-${column.id}`}>
                {column.label}
              </TableSortLabel_1.default>
            </Tooltip_1.default>
            {first = false}
          </Paper_1.default>), this)}
        <Box_1.default flex={0} minWidth={25}/>
      </Box_1.default>
    </Paper_1.default>);
};
exports.default = QListHeader;
